<ng-template #defaultTemplate></ng-template>

<sz-modal
  [(visible)]="visible"
  [title]="title"
  [width]="widthStr"
  [height]="heightStr"
  [showTitle]="showTitle"
  [showCloseButton]="showCloseButton"
  [hideOnOutsideClick]="true"
  (onHidden)="onPopupHidden()">

  <div class="popup-container"
    [class.is-apple-device]="isAppleDevice"
    [class.fixed-footer]="!!footerTemplate"
    [class.auto-height]="height === 'auto'">
    @if (headerTemplate) {
      <div class="popup-content-header">
        <ng-container [ngTemplateOutlet]="headerTemplate ? headerTemplate: defaultTemplate"></ng-container>
      </div>
    }

    @if (!isDelayContent) {
      <div class="popup-content-body">
        <div class="overflow-y-auto h-full popup-container-scroll-view">
          <div class="popup-content-wrapper" [class.p-0]="!paddingContentWrapper"
            [class.fixed-height]="!autoContentContainerHeight && isFixedHeight">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    }

    @if (footerTemplate) {
      <div class="popup-content-footer">
        <div class="popup-footer-wrapper">
          <ng-container [ngTemplateOutlet]="footerTemplate ? footerTemplate: defaultTemplate"></ng-container>
        </div>
      </div>
    }
  </div>
</sz-modal>
